import { ajax } from './createApi'

/**
 *
 *
 * @export 判断用户是不是第一次查车
 * @param {*} params   vclNs 车牌号
 * @returns
 */
export function isFirstSearchCar (params) {
  return ajax({
    method: 'POST',
    url: '/truck/api/location/isFirstQuery',
    data: params
  })
}

/**
 *
 *
 * @export 如果用户是第一次查车，增加历史记录
 * @param {*} params vnos 需要增加的是车牌号
 * @returns
 */
export function addFirstQueryRecord (params) {
  const { vnos } = params
  return ajax({
    method: 'POST',
    url: `/truck/api/location/addFirstQueryRecord?vnos=${vnos}`,
    data: null
  })
}